(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    var dialog = document.getElementById('CartDrawer');
    if (!dialog) return;

    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (rootUrl.charAt(rootUrl.length - 1) !== '/') rootUrl += '/';

    var stringsEl = document.querySelector('[data-cart-drawer-strings]');
    var strings = stringsEl ? JSON.parse(stringsEl.textContent) : {};

    var body        = dialog.querySelector('[data-cart-drawer-body]');
    var footer      = dialog.querySelector('[data-cart-drawer-footer]');
    var countEls    = document.querySelectorAll('[data-cart-count]');
    var drawerCount = dialog.querySelector('[data-cart-drawer-count]');
    var subtotalEl  = dialog.querySelector('[data-cart-drawer-subtotal]');

    function open() {
      if (typeof dialog.showModal === 'function' && !dialog.open) {
        dialog.showModal();
      } else if (!dialog.hasAttribute('open')) {
        dialog.setAttribute('open', '');
      }
      document.documentElement.style.overflow = 'hidden';
    }

    function close() {
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
      document.documentElement.style.overflow = '';
    }

    function escapeHtml(str) {
      return String(str || '').replace(/[&<>"']/g, function (c) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
      });
    }

    function formatMoney(cents) {
      var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      try {
        return (cents / 100).toLocaleString(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: currency,
        });
      } catch (e) {
        return currency + ' ' + (cents / 100).toFixed(2);
      }
    }

    function renderEmpty() {
      return (
        '<div data-cart-drawer-empty class="flex flex-col items-center justify-center text-center py-20 px-8 h-full">' +
          '<p class="font-serif text-xl font-light italic mb-4 text-black/70">' + escapeHtml(strings.empty_title) + '</p>' +
          '<p class="text-black/40 text-[12px] tracking-[.05em] mb-9 max-w-[24ch]">' + escapeHtml(strings.empty_body) + '</p>' +
          '<a href="' + escapeHtml(strings.all_products_url) + '" class="inline-block text-black text-[10px] tracking-[.38em] uppercase font-light border border-black/20 px-9 py-[14px] hover:border-v-rose hover:text-v-rose transition-all duration-300">' +
            escapeHtml(strings.start_shopping) +
          '</a>' +
        '</div>'
      );
    }

    function renderLine(item, index) {
      var imageHtml = item.image
        ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title) + '" class="w-full h-full object-cover" loading="lazy">'
        : '';
      var variantHtml = (item.variant_title && item.variant_title.toLowerCase().indexOf('default') === -1)
        ? '<p class="text-black/45 text-[11px] tracking-[.04em] mt-1">' + escapeHtml(item.variant_title) + '</p>'
        : '';

      return (
        '<li class="flex gap-4 p-5" data-cart-line="' + index + '">' +
          '<a href="' + escapeHtml(item.url) + '" class="shrink-0 w-20 h-24 bg-[#f0ebe9] overflow-hidden">' + imageHtml + '</a>' +
          '<div class="flex-1 min-w-0 flex flex-col">' +
            '<div class="flex items-start justify-between gap-2">' +
              '<a href="' + escapeHtml(item.url) + '" class="font-serif text-[15px] font-light leading-snug hover:text-v-rose transition-colors">' +
                escapeHtml(item.product_title) +
              '</a>' +
              '<button type="button" data-cart-remove data-line="' + index + '" aria-label="' + escapeHtml(strings.remove) + '" class="text-black/40 hover:text-v-rose transition-colors">' +
                '<svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3" d="M6 18L18 6M6 6l12 12"/></svg>' +
              '</button>' +
            '</div>' +
            variantHtml +
            '<div class="mt-auto flex items-center justify-between pt-3">' +
              '<div class="inline-flex items-center border border-black/15">' +
                '<button type="button" data-cart-qty-change="dec" data-line="' + index + '" class="w-7 h-7 flex items-center justify-center hover:bg-black/5" aria-label="' + escapeHtml(strings.decrease) + '">−</button>' +
                '<span data-cart-qty="' + index + '" class="w-7 text-center text-sm">' + item.quantity + '</span>' +
                '<button type="button" data-cart-qty-change="inc" data-line="' + index + '" class="w-7 h-7 flex items-center justify-center hover:bg-black/5" aria-label="' + escapeHtml(strings.increase) + '">+</button>' +
              '</div>' +
              '<p class="text-sm font-light">' + formatMoney(item.final_line_price) + '</p>' +
            '</div>' +
          '</div>' +
        '</li>'
      );
    }

    function render(cart) {
      countEls.forEach(function (el) {
        el.textContent = cart.item_count;
        el.classList.toggle('hidden', cart.item_count === 0);
      });
      if (drawerCount) drawerCount.textContent = '(' + cart.item_count + ')';
      if (subtotalEl)  subtotalEl.textContent = formatMoney(cart.total_price);
      if (footer)      footer.classList.toggle('hidden', cart.item_count === 0);

      if (!body) return;
      if (cart.item_count === 0) {
        body.innerHTML = renderEmpty();
        return;
      }
      var html = '<ul data-cart-drawer-lines class="divide-y divide-black/8">';
      cart.items.forEach(function (item, i) { html += renderLine(item, i + 1); });
      html += '</ul>';
      body.innerHTML = html;
    }

    function refresh() {
      return fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) { render(cart); return cart; });
    }

    // ── Open / close ────────────────────────────────────────────────
    document.addEventListener('click', function (e) {
      var openBtn  = e.target.closest('[data-cart-drawer-open]');
      var closeBtn = e.target.closest('[data-cart-drawer-close]');

      if (openBtn) {
        e.preventDefault();
        open();
        refresh();
        return;
      }

      if (closeBtn) {
        if (closeBtn.tagName === 'A' && closeBtn.getAttribute('href')) {
          close();
          return;
        }
        e.preventDefault();
        close();
        return;
      }

      if (e.target === dialog) {
        var rect = dialog.getBoundingClientRect();
        var inside =
          e.clientX >= rect.left && e.clientX <= rect.right &&
          e.clientY >= rect.top  && e.clientY <= rect.bottom;
        if (!inside) close();
      }
    });

    dialog.addEventListener('cancel', function (e) {
      e.preventDefault();
      close();
    });

    // ── Quantity / remove ───────────────────────────────────────────
    body.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('[data-cart-qty-change]');
      var rmBtn  = e.target.closest('[data-cart-remove]');

      if (qtyBtn) {
        var line = parseInt(qtyBtn.getAttribute('data-line'), 10);
        var dir  = qtyBtn.getAttribute('data-cart-qty-change');
        var qtyEl = body.querySelector('[data-cart-qty="' + line + '"]');
        if (!qtyEl) return;
        var current = parseInt(qtyEl.textContent.trim(), 10) || 0;
        var next = dir === 'inc' ? current + 1 : Math.max(0, current - 1);
        changeLine(line, next);
      }

      if (rmBtn) {
        changeLine(parseInt(rmBtn.getAttribute('data-line'), 10), 0);
      }
    });

    function changeLine(line, quantity) {
      return fetch(rootUrl + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity }),
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) { render(cart); return cart; });
    }

    // ── Intercept product forms ─────────────────────────────────────
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.action || form.action.indexOf('/cart/add') === -1) return;

      e.preventDefault();
      var btn = form.querySelector('button[type="submit"], input[type="submit"]');
      if (btn) btn.setAttribute('disabled', 'disabled');

      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/javascript' },
        body: new FormData(form),
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function () { return refresh(); })
        .then(function () { open(); })
        .catch(function (err) {
          if (err && err.description) alert(err.description);
        })
        .finally(function () {
          if (btn) btn.removeAttribute('disabled');
        });
    });

    // Initial sync (handles cross-tab cart changes)
    refresh();
  })();
  } catch(e) { console.error(e); }
})();

})();
